import { render, staticRenderFns } from "./SdtRols.vue?vue&type=template&id=12871b71"
import script from "./SdtRols.vue?vue&type=script&lang=js"
export * from "./SdtRols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports